import { render } from "./candidateListDetail.vue?vue&type=template&id=420741d2&ts=true"
import script from "./candidateListDetail.vue?vue&type=script&lang=ts"
export * from "./candidateListDetail.vue?vue&type=script&lang=ts"

import "./candidateListDetail.vue?vue&type=style&index=0&id=420741d2&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__